import type { ReactNode } from 'react';
import type { StatusGruppe } from '../runs/status.js';
import stile from './statusmarke.module.css';

/**
 * Kleine Statusmarke wie `StatusChip` der Content-Factory (components/chip/status-chip.tsx):
 * 11px, Pille, Punkt plus Text. Wartend und neutral bleiben weiss; bunt wird es erst, wenn es
 * gut oder schlecht ausgeht. Nie Farbe allein: der Text traegt die Aussage.
 */
export type Ton = 'neutral' | 'laeuft' | 'wartend' | 'erfolg' | 'warnung' | 'fehler';

/** Der Ton je Statusgruppe, EINMAL fuer Fortschritt und Freigabe. */
export const TON_JE_GRUPPE: Record<StatusGruppe, Ton> = {
  laeuft: 'laeuft',
  wartet: 'wartend',
  fertig: 'erfolg',
  fehler: 'fehler',
};

export function Statusmarke({ ton, children }: { ton: Ton; children: ReactNode }) {
  return (
    <span className={stile.marke} data-ton={ton}>
      <span className={stile.punkt} aria-hidden="true" />
      {children}
    </span>
  );
}
